module.exports = __webpack_public_path__ + "img/door-open.e3848172.gif";